import React from 'react';
import BlogPost from '../BlogPost';
import './index.css';

const DUMMY_POSTS = [
    {
        id: 1,
        title: 'The Art of Traditional Sweets',
        author: 'Admin',
        date: new Date().toISOString().split('T')[0],
        image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&q=80&w=600',
        excerpt: 'Discover the heritage and recipes passed down through generations.',
        description: 'Discover the heritage and recipes passed down through generations.',
        link: '#'
    },
    {
        id: 2,
        title: 'New Additions to Our Menu',
        author: 'Admin',
        date: new Date().toISOString().split('T')[0],
        image: 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?auto=format&fit=crop&q=80&w=600',
        excerpt: 'Explore the latest delicious items we have just launched.',
        description: 'Explore the latest delicious items we have just launched.',
        link: '#'
    },
    {
        id: 3,
        title: 'Behind the Scenes: Our Kitchen',
        author: 'Admin',
        date: new Date().toISOString().split('T')[0],
        image: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?auto=format&fit=crop&q=80&w=600',
        excerpt: 'Take a peek at how our chefs prepare your favorite meals daily.',
        description: 'Take a peek at how our chefs prepare your favorite meals daily.',
        link: '#'
    }
];

const ModernBlog = ({ config }) => {
    const { blog } = config;
    let posts = blog?.posts || [];

    // Fallback to dummy posts to ensure the section renders for preview
    if (posts.length === 0) {
        posts = DUMMY_POSTS;
    }

    return (
        <div id="blog" className="blog-main pad-top-100 pad-bottom-100 parallax">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <h2 className="block-title text-center" style={{ color: 'var(--color-text)' }}>
                            {blog.heading}
                        </h2>
                        {blog.sub_heading && (
                            <p
                                className="title-caption text-center"
                                style={{
                                    display: "block",
                                    width: "100%",
                                    color: "var(--color-primary)",
                                    padding: "2px",
                                    fontWeight: 700,
                                    lineHeight: "var(--line-height)",
                                    fontSize: "14px",
                                    letterSpacing: "2px",
                                    textTransform: "uppercase",
                                    marginBottom: "15px",
                                    textAlign: "center",
                                }}
                            >
                                {blog.sub_heading}
                            </p>

                        )}
                        <div className="modern-testimonials__title-line" />
                        <div className="blog-box clearfix">
                            {posts.map((post, index) => (
                                <BlogPost key={index} post={post} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const CafeBlog = ({ config }) => {
    const { blog } = config;
    let posts = blog?.posts || [];

    if (posts.length === 0) {
        posts = DUMMY_POSTS;
    }

    return (
        <section id="blog" className="cafe-blog pad-top-100 pad-bottom-100">
            <div className="container">
                <div className="text-center mb-5">
                    {blog.subHeading && <span className="cafe-blog__kicker">{blog.subHeading}</span>}
                    {blog.heading && <h2 className="cafe-blog__title">{blog.heading}</h2>}
                    <div className="cafe-menu__ornament">
                        <span className="cafe-ornament-line" />
                        <span className="cafe-ornament-icon">☕</span>
                        <span className="cafe-ornament-line" />
                    </div>
                </div>

                <div className="cafe-blog__grid">
                    {posts.map((post, idx) => (
                        <div key={idx} className="cafe-blog__card">
                            <div className="cafe-blog__img-box">
                                <img src={post.image || post.imageSrc} alt={post.title} />
                                <div className="cafe-blog__date">
                                    <span className="cafe-blog__day">{new Date(post.date).getDate() || ''}</span>
                                    <span className="cafe-blog__month">{(new Date(post.date).toLocaleString('default', { month: 'short' }) || '').toUpperCase()}</span>
                                </div>
                            </div>
                            <div className="cafe-blog__info">
                                <h4 className="cafe-blog__card-title">{post.title}</h4>
                                <p className="cafe-blog__card-excerpt">{post.excerpt || post.description || "Read more about our latest updates and stories."}</p>
                                <a href={post.link || "#"} className="cafe-blog__read-more">
                                    Read Article <i className="fa fa-angle-right" />
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="text-center mt-5">
                    <button className="cafe-blog__view-all">View All Posts</button>
                </div>
            </div>
        </section>
    );
};

const TraditionalBlog = ({ config }) => {
    const { blog } = config;
    let posts = blog?.posts || [];
    if (posts.length === 0) {
        posts = DUMMY_POSTS;
    }

    return (
        <section id="blog" className="ts-blog">
            <div className="container">
                <div className="ts-blog__header">
                    {blog.heading && <h3 className="ts-blog__heading">{blog.heading}</h3>}
                    {blog.subHeading && <p className="ts-blog__subheading">{blog.subHeading}</p>}
                </div>
                <div className="ts-blog__grid">
                    {posts.map((post, idx) => (
                        <div key={post.id || idx} className="ts-blog__card">
                            <div className="ts-blog__img">
                                <img src={post.image || post.imageSrc} alt={post.title} />
                            </div>
                            <div className="ts-blog__content">
                                <span className="ts-blog__date">{post.date}</span>
                                <h4 className="ts-blog__title">{post.title}</h4>
                                <p className="ts-blog__excerpt">{post.excerpt || post.description || "Learn more about our heritage recipes."}</p>

                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

const HeritageBlog = ({ config }) => {
    const { blog } = config;
    let posts = blog?.posts || [];
    if (posts.length === 0) {
        posts = DUMMY_POSTS;
    }

    return (
        <section id="blog" className="hr-blog">
            <div className="container">
                <div className="hr-blog__header">
                    {blog.subHeading && <span className="hr-blog__kicker">{blog.subHeading}</span>}
                    {blog.heading && <h2 className="hr-blog__title">{blog.heading}</h2>}
                    <div className="hr-divider">
                        <span></span><i className="fa fa-gem"></i><span></span>
                    </div>
                </div>
                <div className="hr-blog__grid">
                    {posts.map((post, idx) => (
                        <div key={post.id || idx} className="hr-blog__card">
                            <div className="hr-blog__img-box">
                                <img src={post.image || post.imageSrc} alt={post.title} />
                                <div className="hr-blog__date-badge">
                                    <span className="hr-blog__day">{new Date(post.date).getDate() || ''}</span>
                                    <span className="hr-blog__month">{(new Date(post.date).toLocaleString('default', { month: 'short' }) || '').toUpperCase()}</span>
                                </div>
                            </div>
                            <div className="hr-blog__info">
                                <h4 className="hr-blog__card-title">{post.title}</h4>
                                <p className="hr-blog__card-excerpt">{post.excerpt || post.description || "Discover the royal stories behind our culinary artistry."}</p>
                                <a href={post.link || "#"} className="hr-blog__read-more">Read Article <i className="fa fa-long-arrow-right" /></a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

const ModernMithaiBlog = ({ config }) => {
    const { blog } = config;
    let posts = blog?.posts || [];
    if (posts.length === 0) {
        posts = DUMMY_POSTS;
    }

    return (
        <section id="blog" className="mm-blog">
            <div className="container">
                <div className="mm-blog__header text-center">
                    {blog.heading && <h2 className="mm-blog__title">{blog.heading}</h2>}
                    {blog.subHeading && <p className="mm-blog__subtitle">{blog.subHeading}</p>}
                </div>
                <div className="mm-blog__grid">
                    {posts.map((post, idx) => (
                        <div key={post.id || idx} className="mm-blog__card">
                            <div className="mm-blog__img-wrap">
                                <img src={post.image || post.imageSrc} alt={post.title} />
                            </div>
                            <div className="mm-blog__content">
                                <div className="mm-blog__meta">
                                    <span>{post.date}</span>
                                    <span>{post.author || 'Admin'}</span>
                                </div>
                                <h4 className="mm-blog__card-title">{post.title}</h4>
                                <a href={post.link || "#"} className="mm-blog__read-more">Read Full Story</a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};


const BlogSection = ({ config }) => {
    const type = (config.templateType || 'template1').toLowerCase().replace(/-/g, '_');

    switch (type) {
        case 'template4':
        case 'traditional_sweets':
        case 'template5':
            return <TraditionalBlog config={config} />;

        case 'template10':
        case 'heritage_royal':
            return <HeritageBlog config={config} />;

        case 'template11':
        case 'modern_mithai':
        case 'template12':
            return <ModernMithaiBlog config={config} />;

        case 'template14':
        case 'cafe_premium':
        case 'template13':
            return <CafeBlog config={config} />;

        case 'template1':
        case 'template2':
        case 'template3':
        case 'template6':
        case 'template7':
        case 'template8':
        case 'template9':
        case 'template15':
        case 'dry_fruits':
        default:
            return <ModernBlog config={config} />;
    }
};

export default BlogSection;